import React from "react";
import useSupportTickets from "./useSupportTickets";
import { useForm } from "react-hook-form";

const TYPE_OPTIONS = [
  "technical",
  "billing",
  "general",
  "bugReport",
  "featureRequest",
  "account",
];

const IMPACT_LEVELS = ["low", "medium", "high", "critical"];

function CreateSupportTicket({ onSetActiveTab }) {
  const { createSupportTicketFn, isCreatingSupportTicket } =
    useSupportTickets();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      type: "",
      details: "",
      impactLevel: "low",
      image: "",
    },
  });

  const onSubmit = (data) => {
    const formData = data;
    createSupportTicketFn(formData, {
      onSuccess: () => {
        reset();
        onSetActiveTab("list");
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-4 w-full bg-white rounded shadow p-8"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Type</label>
          <select
            {...register("type", {
              required: "Type is required",
            })}
            className="border p-2 rounded w-full"
          >
            <option value="">Select type</option>
            {TYPE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {errors.type && (
            <p className="text-red-500 text-sm mt-1">{errors.type.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Details</label>
          <input
            {...register("details", { required: "Details is required" })}
            placeholder="Details"
            className="border p-2 rounded w-full"
          />
          {errors.details && (
            <p className="text-red-500 text-sm mt-1">
              {errors.details.message}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Impact Level</label>
          <select
            {...register("impactLevel", {
              required: "Impact level is required",
            })}
            className="border p-2 rounded w-full"
          >
            <option value="">Select impact level</option>
            {IMPACT_LEVELS.map((level) => (
              <option key={level} value={level}>
                {level}
              </option>
            ))}
          </select>
          {errors.impactLevel && (
            <p className="text-red-500 text-sm mt-1">
              {errors.impactLevel.message}
            </p>
          )}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Image</label>
        <input
          type="file"
          accept="image/*"
          {...register("image")}
          className="border p-2 rounded w-full"
        />
      </div>

      <div className="flex gap-4 mt-8">
        <button
          type="submit"
          disabled={isCreatingSupportTicket}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          {isCreatingSupportTicket ? "Creating..." : "Create"}
        </button>
        <button
          type="button"
          onClick={() => onSetActiveTab("list")}
          className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300 transition-colors"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

export default CreateSupportTicket;
